import { Injectable } from '@angular/core';
import { EventTime } from '../domain/recurrence/event.time';
import { OccurrenceGeneratorFactory } from '../domain/recurrence/generators/occurrence.generator.factory';
import { RecurrenceRule } from '../domain/recurrence/recurrence.rule';

@Injectable({ providedIn: 'root' })
export class OccurrenceService {
  expand(rule: RecurrenceRule): EventTime[] {
    return OccurrenceGeneratorFactory.for(rule.kind).generate(rule);
  }
}
